import { ROUTES, WORKSPACE_BASE } from '@/config/routes';
import { parsePositiveInt } from '@/lib/routeParams';

/** 기준 연도 주소 파라미터 이름 — 기존 캘린더 공유 링크(`?year=`)와 같아 하위 호환된다(specs/032 R8). */
export const YEAR_PARAM = 'year';

/** 주소의 연도 — 없거나 형식이 틀리면 null. */
export function readYearParam(params: URLSearchParams): null | number {
  return parsePositiveInt(params.get(YEAR_PARAM));
}

/**
 * 연도를 주소에 담지 않는 경로 — 사업 상세는 그 사업의 연도로 고정이라(FR-020) 헤더 연도를 주소에 싣지 않는다.
 */
export function isYearFreePath(pathname: string): boolean {
  return (
    pathname.startsWith(`${WORKSPACE_BASE}/programs/`) ||
    [ROUTES.workspace.certifications, ROUTES.workspace.mobile.certifications].some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    )
  );
}
